import type { Flag } from "@medplum/fhirtypes";
import { FLAG_COLLECTION_NAME } from "../../fhir";
import { createSubscriptionHook } from "./create-subscription-hook";

export const useFlagSubscription = createSubscriptionHook<Flag>("Flag", FLAG_COLLECTION_NAME);
